<template>
    <v-dialog v-model="isShow" persistent max-width="400">
        <v-card>
            <v-card-title class="headline">Security Setup Required</v-card-title>
            <v-card-text>
                <p class="mb-4">Please complete the following security steps:</p>

                <div class="d-flex flex-column">
                    <v-btn
                        :to="{ name: 'password-update' }"
                        color="primary"
                        class="mb-3 w-100"
                        :disabled="passwordUpdated"
                    >
                        <template v-if="passwordUpdated">
                            <v-icon left>mdi-check</v-icon>
                            <span class="text-success">Password Updated</span>
                        </template>
                        <template v-else>
                            Update Password
                        </template>
                    </v-btn>

                    <div class="w-100">
                        <v-btn
                            :to="{ name: 'two-factor-setup' }"
                            color="primary"
                            :disabled="!passwordUpdated"
                            class="mb-1 w-100"
                        >
                            Setup 2FA
                        </v-btn>
                        <div v-if="!passwordUpdated" class="caption text--disabled">
                            Complete password update first to enable 2FA setup
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        passwordUpdated: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isShow: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>
